var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      staticClass: "cant-load-hall-svg",
      attrs: {
        width: "218",
        height: "194",
        viewBox: "0 0 218 194",
        xmlns: "http://www.w3.org/2000/svg",
        fill: _vm.color,
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2_3)" } }, [
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.6878 50.1492L6.31429 53.266C6.2691 53.332 6.2198 53.3981 6.17461 53.4683L11.7905 50.207L11.6878 50.1492Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M26.7402 41.5337L26.6375 41.4759L11.7905 50.0914L11.8932 50.1492L26.7402 41.5337Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M54.7129 25.3058L54.6102 25.248L41.0121 33.1369L41.1148 33.1947L54.7129 25.3058Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.7366 16.5912L69.6339 16.5293L54.713 25.1861L54.8157 25.248L69.7366 16.5912Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.8393 16.5292L88.4946 5.70927L88.0591 5.84138L69.7366 16.488L69.8393 16.5292Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M41.0121 33.2567L40.9094 33.1947L26.7402 41.414L26.8429 41.4759L41.0121 33.2567Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M66.9225 32.3897L66.8198 32.332L53.2217 40.2209L53.3244 40.2787L66.9225 32.3897Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M24.0001 57.2909L23.8974 57.2331L11.1496 64.6268L11.2523 64.6887L24.0001 57.2909Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.498 0.0289017L107.951 8.46691L108.054 8.52883L122.712 0.0206451L122.498 0.0289017Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.947 8.58662L107.844 8.52883L94.1557 16.4715L94.2584 16.5293L107.947 8.58662Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.1557 16.5912L94.053 16.5293L81.9462 23.5554L82.0489 23.6132L94.1557 16.5912Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M53.2217 40.3365L53.119 40.2787L38.9498 48.4979L39.0525 48.5598L53.2217 40.3365Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.0252 32.3319L81.9462 23.6751L81.8435 23.6132L66.9225 32.27L67.0252 32.3319Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M38.8471 48.5598L24.0001 57.1712L24.1028 57.2331L38.9498 48.6176L38.8471 48.5598Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.0469 64.6887L0.24649 70.9553V71.075L11.1496 64.7465L11.0469 64.6887Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.3481 48.9974L81.9462 41.1044L81.8435 41.0466L68.2453 48.9355L68.3481 48.9974Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M13.9391 80.4418L3.94387 86.2543L3.99317 86.3451L14.0418 80.5162L13.9391 80.4418Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M26.1733 73.4611L26.0706 73.4033L14.0418 80.384L14.1445 80.4418L26.1733 73.4611Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M38.921 65.9477L26.1733 73.3455L26.2801 73.4033L39.0237 66.0097L38.921 65.9477Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M138.101 8.52883L150.089 1.57284L149.929 1.54807L138.015 8.4669L138.101 8.52883Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.077 17.2434L137.998 8.58662L137.896 8.52883L122.975 17.1856L123.077 17.2434Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.1426 48.9974L53.9735 57.2166L54.0762 57.2744L68.2453 49.0552L68.1426 48.9974Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.9698 32.3897L96.8671 32.332L81.9462 40.9888L82.0489 41.0466L96.9698 32.3897Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M53.9735 57.3364L53.8707 57.2744L39.0237 65.89L39.1264 65.9478L53.9735 57.3364Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M109.179 25.3058L109.077 25.248L96.9698 32.27L97.0725 32.3319L109.179 25.3058Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.975 17.3053L122.872 17.2434L109.179 25.1861L109.282 25.248L122.975 17.3053Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M164.012 9.39162L169.545 6.1675L169.414 6.12209L163.901 9.32144L164.012 9.39162Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.7714 81.35L27.7426 88.3308L27.8454 88.3886L39.8742 81.4119L39.7714 81.35Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M136.778 25.1943L151.699 16.5375L151.597 16.4756L136.676 25.1324L136.778 25.1943Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M52.7246 73.9565L52.6219 73.8987L39.8742 81.2922L39.9769 81.35L52.7246 73.9565Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M110.671 40.3365L110.568 40.2787L95.647 48.9355L95.7497 48.9974L110.671 40.3365Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M14.4239 96.1785L14.3212 96.1165L2.39919 103.035L2.5019 103.093L14.4239 96.1785Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M2.29648 103.093L0.529955 104.117C0.529955 104.162 0.529956 104.208 0.509415 104.249L2.39919 103.155L2.29648 103.093Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M27.7426 88.4505L27.6399 88.3886L14.4239 96.0588L14.5266 96.1166L27.7426 88.4505Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M95.647 49.0552L95.5443 48.9974L81.9462 56.8823L82.0489 56.9442L95.647 49.0552Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.9462 57.002L81.8435 56.9442L67.6743 65.1634L67.777 65.2253L81.9462 57.002Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.983 33.1947L136.676 25.2521L136.573 25.1943L122.88 33.1369L122.983 33.1947Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.5716 65.2253L52.7246 73.8367L52.8273 73.8987L67.6743 65.2831L67.5716 65.2253Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.88 33.2567L122.778 33.1947L110.671 40.2209L110.773 40.2787L122.88 33.2567Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M151.802 16.4756L163.909 9.45354L163.806 9.39162L151.699 16.4178L151.802 16.4756Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M18.4458 112.464L18.3431 112.406L4.2643 120.576L4.367 120.634L18.4458 112.464Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M55.9249 90.721L55.8222 90.6632L43.7934 97.6399L43.8961 97.7018L55.9249 90.721Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M167.849 25.7888L179.955 18.7626L179.853 18.7048L167.746 25.7268L167.849 25.7888Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M111.698 58.3643L111.595 58.3065L97.9969 66.1955L98.0996 66.2533L111.698 58.3643Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.3719 105.43L18.4458 112.344L18.5485 112.406L30.4746 105.488L30.3719 105.43Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M126.721 49.6497L126.619 49.5919L111.698 58.2487L111.8 58.3065L126.721 49.6497Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M43.7934 97.7596L43.6907 97.7018L30.4746 105.368L30.5773 105.43L43.7934 97.7596Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M126.824 49.5919L138.931 42.5657L138.828 42.5079L126.721 49.53L126.824 49.5919Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M4.16161 120.634L1.7501 122.033C1.7501 122.066 1.7501 122.099 1.77886 122.136L4.24377 120.692L4.16161 120.634Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M97.8942 66.2533L83.725 74.4766L83.8277 74.5344L97.9969 66.3152L97.8942 66.2533Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M180.058 18.7048L187.835 14.1927L187.732 14.1349L179.955 18.6429L180.058 18.7048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M83.725 74.5963L83.6223 74.5344L68.7753 83.1499L68.878 83.2077L83.725 74.5963Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M139.034 42.5079L152.722 34.5653L152.619 34.5034L138.931 42.446L139.034 42.5079Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.6726 83.2077L55.9249 90.6013L56.0276 90.6632L68.7753 83.2696L68.6726 83.2077Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.825 34.5034L167.746 25.8466L167.643 25.7888L152.722 34.4456L152.825 34.5034Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.205 50.1492L165.897 42.2066L165.794 42.1488L152.102 50.0914L152.205 50.1492Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.9461 90.9109L81.8434 90.849L69.0998 98.2467L69.2025 98.3045L81.9461 90.9109Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M193.233 26.3461L199.621 22.6307L199.539 22.5564L193.13 26.2718L193.233 26.3461Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M111.168 73.9565L111.065 73.8987L96.8959 82.1179L96.9986 82.1798L111.168 73.9565Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.0998 98.3664L68.993 98.3045L56.9642 105.285L57.0669 105.343L69.0998 98.3664Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M31.5181 120.048L17.4393 128.217L17.542 128.275L31.6208 120.11L31.5181 120.048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M43.6455 113.129L43.5427 113.071L31.6208 119.99L31.7235 120.048L43.6455 113.129Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M181.024 33.4301L193.13 26.408L193.028 26.3461L180.921 33.3723L181.024 33.4301Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M17.4393 128.337L17.3366 128.275L5.38172 135.215L5.48443 135.272L17.4393 128.337Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M124.869 65.89L124.971 65.9478L139.892 57.2909L139.79 57.2331L124.869 65.89Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M165.897 42.0869L166 42.1488L180.921 33.492L180.818 33.43L165.897 42.0869Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.7932 82.1798L81.9462 90.7912L82.0489 90.849L96.8959 82.2376L96.7932 82.1798Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M139.892 57.1712L139.995 57.2332L152.102 50.207L151.999 50.1492L139.892 57.1712Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M111.168 73.8367L111.27 73.8987L124.869 66.0097L124.766 65.9478L111.168 73.8367Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M5.27494 135.272L4.15751 135.921L4.0548 136.102L5.37764 135.33L5.27494 135.272Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.8615 105.343L43.6455 113.009L43.7482 113.071L56.9642 105.405L56.8615 105.343Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.8434 105.76L69.8147 112.741L69.9174 112.799L81.9461 105.818L81.8434 105.76Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.8147 112.856L69.712 112.799L56.4959 120.465L56.5986 120.527L69.8147 112.856Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M124.121 81.35L137.719 73.4611L137.616 73.4033L124.018 81.2922L124.121 81.35Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.1829 135.731L18.2281 142.666L18.3308 142.728L30.2856 135.793L30.1829 135.731Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M137.719 73.3455L137.822 73.4033L152.743 64.7465L152.64 64.6887L137.719 73.3455Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.743 64.6267L152.845 64.6887L164.952 57.6625L164.85 57.6047L152.743 64.6267Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M44.4712 127.561L44.3685 127.503L30.2856 135.673L30.3883 135.731L44.4712 127.561Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.3932 120.527L44.4712 127.445L44.5739 127.503L56.4959 120.584L56.3932 120.527Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.846 49.6002L193.771 40.9433L193.669 40.8856L178.743 49.5424L178.846 49.6002Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M164.952 57.5428L165.055 57.6047L178.744 49.6621L178.641 49.6002L164.952 57.5428Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M193.771 40.8278L193.874 40.8856L205.981 33.8594L205.878 33.8016L193.771 40.8278Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M109.746 89.6931L109.644 89.6312L94.7966 98.2467L94.8993 98.3045L109.746 89.6931Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M18.2281 142.786L18.1254 142.728L3.1058 151.438L3.2085 151.5L18.2281 142.786Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M109.746 89.5734L109.849 89.6312L124.018 81.4119L123.915 81.35L109.746 89.5734Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.7966 98.3664L94.6939 98.3045L81.9462 105.702L82.0489 105.76L94.7966 98.3664Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M206.084 33.8016L208.113 32.6209C208.097 32.5911 208.079 32.5622 208.06 32.5342L205.981 33.7438L206.084 33.8016Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M3.00309 151.5L0.127357 153.172V153.288L3.10169 151.558L3.00309 151.5Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M190.879 56.5809L190.982 56.6387L205.903 47.9819L205.8 47.9241L190.879 56.5809Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.2569 149.766L15.2373 158.477L15.34 158.539L30.3596 149.824L30.2569 149.766Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.8434 119.837L68.6274 127.503L68.7301 127.565L81.9462 119.899L81.8434 119.837Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M149.953 80.4418L164.874 71.785L164.772 71.7272L149.851 80.384L149.953 80.4418Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.6274 127.623L68.5247 127.565L56.6027 134.48L56.7054 134.542L68.6274 127.623Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M121.981 96.6697L136.15 88.4505L136.047 88.3886L121.878 96.6119L121.981 96.6697Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M136.15 88.3308L136.252 88.3886L149.851 80.4996L149.748 80.4418L136.15 88.3308Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.0776 112.856L93.9749 112.799L81.9462 119.779L82.0489 119.837L94.0776 112.856Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M164.874 71.6653L164.977 71.7272L177.084 64.7011L176.981 64.6433L164.874 71.6653Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.031 105.343L121.878 96.7317L121.775 96.6697L106.928 105.285L107.031 105.343Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M15.1346 158.539L4.07121 164.958L4.12051 165.049L15.2373 158.597L15.1346 158.539Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M206.005 47.9241L212.681 44.0601C212.672 44.0248 212.666 43.9889 212.661 43.9528L205.903 47.8622L206.005 47.9241Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M177.084 64.5813L177.187 64.6433L190.879 56.7006L190.776 56.6387L177.084 64.5813Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.5 134.542L42.4171 142.711L42.5239 142.769L56.6027 134.6L56.5 134.542Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M106.825 105.343L94.0776 112.741L94.1803 112.799L106.928 105.405L106.825 105.343Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M42.4171 142.831L42.3144 142.769L30.3596 149.705L30.4623 149.766L42.4171 142.831Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M43.5756 157.49L28.5561 166.205L28.6588 166.267L43.6783 157.552L43.5756 157.49Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.296 79.4511L190.403 72.429L190.3 72.3671L178.193 79.3933L178.296 79.4511Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M204.198 64.3089L204.301 64.3667L211.079 60.4325L211.141 60.2798L204.198 64.3089Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M163.169 88.1079L163.272 88.1698L178.193 79.513L178.09 79.4511L163.169 88.1079Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M120.247 113.009L120.35 113.071L135.197 104.46L135.094 104.398L120.247 113.009Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.294 120.527L95.2649 127.503L95.3676 127.565L107.396 120.584L107.294 120.527Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M15.6892 173.673L12.8669 175.324L12.9531 175.394L15.7919 173.743L15.6892 173.673Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.499 120.527L120.247 113.129L120.144 113.071L107.396 120.465L107.499 120.527Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M149.571 96.1166L163.169 88.2276L163.067 88.1698L149.468 96.0588L149.571 96.1166Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.9215 142.327L69.8188 142.27L55.7359 150.435L55.8386 150.497L69.9215 142.327Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M95.2649 127.623L95.1622 127.565L81.9462 135.231L82.0489 135.289L95.2649 127.623Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M55.6332 150.497L43.6783 157.432L43.781 157.49L55.7359 150.555L55.6332 150.497Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.8435 135.289L69.9215 142.208L70.0242 142.27L81.9462 135.351L81.8435 135.289Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M135.299 104.398L149.468 96.1785L149.366 96.1165L135.197 104.34L135.299 104.398Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M190.403 72.3093L190.505 72.3671L204.198 64.4286L204.095 64.3667L190.403 72.3093Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M28.5561 166.325L28.4534 166.267L15.7919 173.611L15.8946 173.673L28.5561 166.325Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M40.5849 173.182L40.6876 173.243L55.7071 164.529L55.6044 164.471L40.5849 173.182Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M93.975 142.208L94.0777 142.27L107.294 134.604L107.191 134.542L93.975 142.208Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M190.222 86.3699L190.325 86.4318L202.431 79.4057L202.329 79.3479L190.222 86.3699Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M27.718 180.649L23.9097 182.854L24.0165 182.912L27.8125 180.707L27.718 180.649Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M119.425 127.445L119.528 127.503L132.276 120.11L132.173 120.048L119.425 127.445Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M93.8723 142.27L81.9462 149.184L82.0489 149.246L93.975 142.327L93.8723 142.27Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.294 134.484L107.396 134.542L119.425 127.561L119.323 127.503L107.294 134.484Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M132.378 120.048L147.225 111.436L147.123 111.374L132.276 119.99L132.378 120.048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M40.4822 173.243L27.8207 180.587L27.9234 180.649L40.5849 173.301L40.4822 173.243Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.7647 157.416L67.8674 157.474L81.9461 149.304L81.8434 149.246L67.7647 157.416Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M147.225 111.317L147.328 111.374L161.497 103.155L161.395 103.093L147.225 111.317Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M202.534 79.3479L204.522 78.192L204.444 78.1177L202.431 79.2859L202.534 79.3479Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M175.301 95.1464L190.222 86.4896L190.119 86.4318L175.198 95.0886L175.301 95.1464Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.6 103.093L175.198 95.2084L175.095 95.1465L161.497 103.035L161.6 103.093Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M209.502 75.3022L209.452 75.2155L204.814 77.903L204.892 77.9773L209.502 75.3022Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.662 157.474L55.7071 164.409L55.8098 164.471L67.7647 157.536L67.662 157.474Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M108.156 150.435L108.259 150.497L121.475 142.831L121.373 142.769L108.156 150.435Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.8886 172.637L69.9913 172.699L81.9462 165.763L81.8435 165.701L69.8886 172.637Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.1277 157.416L96.2304 157.474L108.156 150.555L108.054 150.497L96.1277 157.416Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M121.475 142.711L121.578 142.769L133.607 135.793L133.504 135.731L121.475 142.711Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.51 119.602L175.679 111.383L175.576 111.325L161.407 119.544L161.51 119.602Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M41.8995 188.877L40.5479 189.653L40.6835 189.69L41.9858 188.939L41.8995 188.877Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M189.482 103.374L204.403 94.7171L204.301 94.6593L189.38 103.316L189.482 103.374Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M204.506 94.6593L213.437 89.4784L213.384 89.3876L204.403 94.5974L204.506 94.6593Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M146.457 128.217L146.56 128.275L161.407 119.664L161.304 119.602L146.457 128.217Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M175.679 111.263L175.781 111.325L189.38 103.436L189.277 103.374L175.679 111.263Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M133.607 135.673L133.709 135.731L146.457 128.337L146.354 128.275L133.607 135.673Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.7859 172.699L54.7663 181.413L54.869 181.471L69.8886 172.756L69.7859 172.699Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.025 157.474L81.9462 165.643L82.0489 165.701L96.1277 157.536L96.025 157.474Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M42.0022 188.819L42.1049 188.877L54.7663 181.533L54.6636 181.471L42.0022 188.819Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M108.185 164.409L108.288 164.471L120.214 157.552L120.111 157.49L108.185 164.409Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M120.214 157.432L120.317 157.49L133.533 149.824L133.43 149.766L120.214 157.432Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M66.8239 188.406L66.9266 188.468L81.9462 179.754L81.8435 179.692L66.8239 188.406Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M133.533 149.705L133.635 149.766L145.664 142.786L145.562 142.728L133.533 149.705Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M216.564 101.652L218.207 100.695C218.207 100.662 218.207 100.629 218.178 100.592L216.453 101.595L216.564 101.652Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M201.437 110.309L201.54 110.371L216.461 101.714L216.358 101.652L201.437 110.309Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.0037 172.637L94.1064 172.699L108.185 164.529L108.082 164.471L94.0037 172.637Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M187.839 118.318L201.437 110.429L201.334 110.371L187.736 118.26L187.839 118.318Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M66.7212 188.468L58.4391 193.273H58.6116L66.828 188.51L66.7212 188.468Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.464 126.537L173.567 126.599L187.736 118.38L187.634 118.318L173.464 126.537Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M158.515 135.215L158.617 135.272L173.464 126.657L173.362 126.599L158.515 135.215Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M93.901 172.699L81.9462 179.634L82.0489 179.692L94.0037 172.756L93.901 172.699Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M145.664 142.666L145.767 142.728L158.515 135.33L158.412 135.272L145.664 142.666Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M135.336 166.205L135.439 166.267L148.655 158.597L148.552 158.539L135.336 166.205Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M202.859 127.033L202.961 127.09L216.559 119.201L216.457 119.144L202.859 127.033Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.9657 188.468L89.3738 192.873L89.649 192.832L97.0684 188.526L96.9657 188.468Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.414 173.243L135.336 166.325L135.234 166.267L123.307 173.182L123.414 173.243Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.205 173.243L109.126 181.413L109.229 181.471L123.308 173.301L123.205 173.243Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.534 144.045L160.787 151.438L160.889 151.5L173.637 144.107L173.534 144.045Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M188.587 135.314L188.689 135.371L202.859 127.152L202.756 127.09L188.587 135.314Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M97.0684 188.406L97.1711 188.468L109.126 181.533L109.023 181.471L97.0684 188.406Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.74 144.045L188.587 135.433L188.484 135.371L173.637 143.987L173.74 144.045Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M148.655 158.477L148.758 158.539L160.787 151.558L160.684 151.5L148.655 158.477Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M164.952 57.6625L176.981 64.6433L177.084 64.5813L165.055 57.6047L164.952 57.6625Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M202.329 79.3479L202.431 79.2859L190.505 72.3671L190.403 72.429L202.329 79.3479Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M109.179 25.1861L94.2584 16.5293L94.1557 16.5912L109.077 25.248L109.179 25.1861Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M202.431 79.4057L209.115 83.282C209.054 83.2077 208.988 83.1334 208.926 83.055L202.534 79.3396L202.431 79.4057Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M177.084 64.7011L190.3 72.3671L190.403 72.3093L177.187 64.6433L177.084 64.7011Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M151.999 50.1492L152.102 50.0914L139.034 42.5079L138.931 42.5657L151.999 50.1492Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.102 50.207L164.85 57.6047L164.952 57.5428L152.205 50.1492L152.102 50.207Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0776 9.46179L82.0242 9.55261L94.053 16.5292L94.1557 16.4714L82.0776 9.46179Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M138.828 42.5079L138.931 42.446L122.983 33.1947L122.88 33.2567L138.828 42.5079Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.88 33.1369L109.282 25.248L109.179 25.3058L122.778 33.1947L122.88 33.1369Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.09 79.4511L178.193 79.3933L164.977 71.7272L164.874 71.785L178.09 79.4511Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.9698 32.27L82.0489 23.6132L81.9462 23.6751L96.8671 32.3319L96.9698 32.27Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M204.301 94.6593L204.403 94.5974L190.325 86.4318L190.222 86.4896L204.301 94.6593Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M139.892 57.2909L152.64 64.6887L152.743 64.6268L139.995 57.2331L139.892 57.2909Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M110.671 40.2209L97.0725 32.332L96.9698 32.3897L110.568 40.2787L110.671 40.2209Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M126.721 49.53L110.773 40.2787L110.671 40.3365L126.619 49.5919L126.721 49.53Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.743 64.7465L164.771 71.7272L164.874 71.6653L152.845 64.6887L152.743 64.7465Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M126.721 49.6497L139.79 57.2331L139.892 57.1712L126.824 49.5919L126.721 49.6497Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M216.358 101.652L216.461 101.595L204.506 94.6593L204.403 94.7171L216.358 101.652Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.8434 23.6132L81.9461 23.5554L69.8393 16.5293L69.7366 16.5912L81.8434 23.6132Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.193 79.513L190.119 86.4318L190.222 86.3699L178.296 79.4511L178.193 79.513Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M216.559 119.201L218.252 120.184L218.277 120.081L216.662 119.144L216.559 119.201Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M149.748 80.4418L149.851 80.384L137.822 73.4033L137.719 73.4611L149.748 80.4418Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M216.457 119.144L216.559 119.082L201.54 110.371L201.437 110.429L216.457 119.144Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M111.698 58.3643L124.766 65.9478L124.869 65.89L111.8 58.3065L111.698 58.3643Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M111.698 58.2487L95.7497 48.9974L95.647 49.0552L111.595 58.3065L111.698 58.2487Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M95.647 48.9355L82.0489 41.0466L81.9462 41.1044L95.5443 48.9974L95.647 48.9355Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.8435 41.0466L81.9462 40.9888L67.0252 32.332L66.9225 32.3897L81.8435 41.0466Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M189.38 103.436L201.334 110.371L201.437 110.309L189.482 103.374L189.38 103.436Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M54.7129 25.1861L54.4418 25.0292L54.3679 25.1076L54.6102 25.248L54.7129 25.1861Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M124.869 66.0097L137.616 73.4033L137.719 73.3455L124.971 65.9477L124.869 66.0097Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M189.277 103.374L189.38 103.316L175.301 95.1465L175.198 95.2084L189.277 103.374Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M149.851 80.4996L163.067 88.1698L163.169 88.1079L149.953 80.4418L149.851 80.4996Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M66.9225 32.27L54.8157 25.248L54.713 25.3058L66.8198 32.3319L66.9225 32.27Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M175.095 95.1465L175.198 95.0887L163.272 88.1698L163.169 88.2276L175.095 95.1465Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M41.0121 33.1369L37.0682 30.8458C37.0272 30.8458 36.9902 30.883 36.9491 30.8953L40.9094 33.1947L41.0121 33.1369Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M53.2217 40.2209L41.1148 33.1947L41.0121 33.2567L53.119 40.2787L53.2217 40.2209Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M187.634 118.318L187.736 118.26L175.781 111.325L175.679 111.383L187.634 118.318Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M98.0996 66.2533L97.9969 66.3152L111.065 73.8987L111.168 73.8367L98.0996 66.2533Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M124.018 81.4119L136.047 88.3886L136.15 88.3308L124.121 81.35L124.018 81.4119Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.497 103.155L175.576 111.325L175.679 111.263L161.6 103.093L161.497 103.155Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M149.366 96.1166L149.469 96.0588L136.252 88.3886L136.15 88.4505L149.366 96.1166Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.2453 48.9355L53.3244 40.2787L53.2217 40.3365L68.1426 48.9974L68.2453 48.9355Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M187.736 118.38L202.756 127.09L202.859 127.033L187.839 118.318L187.736 118.38Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.395 103.093L161.497 103.035L149.571 96.1165L149.468 96.1785L161.395 103.093Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.915 81.35L124.018 81.2922L111.27 73.8987L111.168 73.9565L123.915 81.35Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M202.859 127.152L212.64 132.829L212.698 132.738L202.961 127.09L202.859 127.152Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.3481 48.9974L68.2453 49.0552L81.8435 56.9442L81.9462 56.8823L68.3481 48.9974Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M97.9969 66.1955L82.0489 56.9442L81.9462 57.002L97.8942 66.2533L97.9969 66.1955Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M205.878 33.8016L205.981 33.7438L193.233 26.3461L193.13 26.408L205.878 33.8016Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M205.981 33.8594L210.089 36.2496C210.064 36.1959 210.04 36.1423 210.011 36.0886L206.075 33.8016L205.981 33.8594Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M179.853 18.7048L179.955 18.6429L164.011 9.39162L163.909 9.45354L179.853 18.7048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M193.028 26.3461L193.13 26.2883L180.058 18.7048L179.955 18.7626L193.028 26.3461Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M163.794 9.39163L163.896 9.33384L150.697 1.66779L150.413 1.62651L163.794 9.39163Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M167.643 25.7888L167.746 25.7269L151.802 16.4756L151.699 16.5375L167.643 25.7888Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M205.903 47.9819L213.051 52.1307V52.0193L205.993 47.9241L205.903 47.9819Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M151.597 16.4756L151.699 16.4178L138.101 8.52883L137.998 8.58662L151.597 16.4756Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M180.818 33.43L180.921 33.3723L167.849 25.7888L167.746 25.8466L180.818 33.43Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M137.912 8.52883L138.015 8.4669L123.398 0H123.205L137.912 8.52883Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M205.8 47.9241L205.903 47.8622L193.874 40.8856L193.771 40.9433L205.8 47.9241Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M180.921 33.492L193.669 40.8855L193.771 40.8278L181.024 33.43L180.921 33.492Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.743 49.6621L190.776 56.6387L190.879 56.5809L178.846 49.6002L178.743 49.6621Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M178.641 49.6002L178.744 49.5424L166 42.1488L165.897 42.2066L178.641 49.6002Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M190.879 56.7006L204.095 64.3667L204.198 64.3089L190.982 56.6387L190.879 56.7006Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M136.573 25.1943L136.676 25.1324L123.077 17.2434L122.975 17.3053L136.573 25.1943Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M98.609 3.05072L98.457 3.07962L107.844 8.52882L107.951 8.46689L98.609 3.05072Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M122.975 17.1856L108.05 8.52883L107.947 8.58662L122.872 17.2434L122.975 17.1856Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M204.198 64.4245L207.957 66.6083C207.973 66.5785 207.991 66.5495 208.01 66.5216L204.313 64.3667L204.198 64.4245Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M165.794 42.1488L165.897 42.0869L152.825 34.5034L152.722 34.5653L165.794 42.1488Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M152.619 34.5034L152.722 34.4456L136.778 25.1943L136.676 25.2521L152.619 34.5034Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.8959 82.1179L83.8277 74.5344L83.725 74.5963L96.7932 82.1798L96.8959 82.1179Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.304 119.602L161.407 119.544L147.328 111.374L147.225 111.436L161.304 119.602Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M161.407 119.664L173.362 126.599L173.464 126.537L161.51 119.602L161.407 119.664Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.9986 82.1798L96.8959 82.2376L109.644 89.6312L109.746 89.5734L96.9986 82.1798Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.0525 48.5598L38.9498 48.6176L53.8708 57.2744L53.9735 57.2166L39.0525 48.5598Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M121.775 96.6697L121.878 96.6119L109.849 89.6312L109.746 89.6931L121.775 96.6697Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.6743 65.1634L54.0762 57.2744L53.9735 57.3364L67.5716 65.2253L67.6743 65.1634Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M135.197 104.46L147.123 111.374L147.225 111.317L135.299 104.398L135.197 104.46Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M135.094 104.398L135.197 104.34L121.981 96.6697L121.878 96.7317L135.094 104.398Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M26.7403 41.4181L21.9378 38.6316L21.8392 38.6935L26.6375 41.4759L26.7403 41.4181Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.464 126.657L188.484 135.371L188.587 135.314L173.567 126.599L173.464 126.657Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M38.9498 48.4979L26.8429 41.4759L26.7402 41.5337L38.8471 48.5598L38.9498 48.4979Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.777 65.2253L67.6743 65.2831L83.6223 74.5344L83.725 74.4766L67.777 65.2253Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M201.248 142.777L201.351 142.72L188.689 135.371L188.587 135.433L201.248 142.777Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.1264 65.9478L39.0237 66.0097L52.6219 73.8987L52.7246 73.8367L39.1264 65.9478Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.0237 65.89L24.1028 57.2331L24.0001 57.2909L38.921 65.9478L39.0237 65.89Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.7966 98.2467L82.0489 90.849L81.9462 90.9109L94.6939 98.3045L94.7966 98.2467Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.637 144.107L186.298 151.451L186.401 151.393L173.74 144.045L173.637 144.107Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M186.389 151.513L190.542 153.919L190.641 153.858L186.492 151.451L186.389 151.513Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.534 144.045L173.637 143.987L158.617 135.272L158.515 135.33L173.534 144.045Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.878 83.2077L68.7753 83.2696L81.8434 90.849L81.9461 90.7912L68.878 83.2077Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M68.7753 83.1499L52.8273 73.8987L52.7246 73.9565L68.6726 83.2077L68.7753 83.1499Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M132.173 120.048L132.276 119.99L120.35 113.071L120.247 113.129L132.173 120.048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.8932 50.1492L11.7905 50.207L23.8974 57.2332L24.0001 57.1712L11.8932 50.1492Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M132.276 120.11L146.354 128.275L146.457 128.217L132.378 120.048L132.276 120.11Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M106.928 105.405L120.144 113.071L120.247 113.009L107.031 105.343L106.928 105.405Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M146.457 128.337L158.412 135.272L158.515 135.215L146.56 128.275L146.457 128.337Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M106.928 105.285L94.8993 98.3045L94.7966 98.3664L106.825 105.343L106.928 105.285Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.7905 50.0873L9.73642 48.9066L9.66658 48.9851L11.6755 50.1492L11.7905 50.0873Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.8742 81.2922L26.2801 73.4033L26.1733 73.4611L39.7715 81.35L39.8742 81.2922Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.1496 64.6267L2.72785 59.7431L2.69088 59.838L11.0469 64.6887L11.1496 64.6267Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M160.889 151.5L160.787 151.558L173.448 158.906L173.551 158.848L160.889 151.5Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M173.555 158.964L177.223 161.094L177.338 161.045L173.653 158.91L173.555 158.964Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M119.425 127.561L133.504 135.731L133.607 135.673L119.528 127.503L119.425 127.561Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M145.664 142.786L160.684 151.5L160.787 151.438L145.767 142.728L145.664 142.786Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.9461 105.702L69.2025 98.3045L69.0998 98.3664L81.8434 105.76L81.9461 105.702Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M11.2523 64.6887L11.1496 64.7465L26.0706 73.4033L26.1733 73.3455L11.2523 64.6887Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M133.607 135.793L145.562 142.728L145.664 142.666L133.709 135.731L133.607 135.793Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 105.76L81.9462 105.818L93.9749 112.799L94.0776 112.741L82.0489 105.76Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.396 120.584L119.323 127.503L119.425 127.445L107.499 120.527L107.396 120.584Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.396 120.465L94.1803 112.799L94.0776 112.856L107.294 120.527L107.396 120.465Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M39.9769 81.35L39.8742 81.4119L55.8222 90.6632L55.9249 90.6013L39.9769 81.35Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.0998 98.2467L56.0276 90.6632L55.9249 90.721L68.993 98.3045L69.0998 98.2467Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M160.409 165.416L160.462 165.33L148.758 158.539L148.655 158.597L160.409 165.416Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M121.475 142.831L133.43 149.766L133.533 149.705L121.578 142.769L121.475 142.831Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M43.7934 97.6398L27.8454 88.3886L27.7426 88.4505L43.6907 97.7018L43.7934 97.6398Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M14.1445 80.4418L14.0418 80.4996L27.6399 88.3886L27.7426 88.3308L14.1445 80.4418Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M107.294 134.604L121.373 142.769L121.475 142.711L107.396 134.542L107.294 134.604Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.9461 119.779L69.9174 112.799L69.8147 112.856L81.8434 119.837L81.9461 119.779Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M14.0418 80.384L0.24649 72.3795C0.24649 72.4208 0.24649 72.4579 0.24649 72.4992L13.935 80.4418L14.0418 80.384Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.9642 105.285L43.8961 97.7018L43.7934 97.7596L56.8615 105.343L56.9642 105.285Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M95.2649 127.623L107.191 134.542L107.294 134.484L95.3676 127.565L95.2649 127.623Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M133.533 149.824L148.552 158.539L148.655 158.477L133.635 149.766L133.533 149.824Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M57.0669 105.343L56.9642 105.405L69.712 112.799L69.8147 112.741L57.0669 105.343Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 119.837L81.9462 119.899L95.1622 127.565L95.2649 127.503L82.0489 119.837Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.5986 120.527L56.4959 120.584L68.5247 127.565L68.6274 127.503L56.5986 120.527Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.4746 105.368L14.5266 96.1165L14.4239 96.1785L30.3719 105.43L30.4746 105.368Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.5773 105.43L30.4746 105.488L43.5428 113.071L43.6455 113.009L30.5773 105.43Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M144.148 171.439L144.304 171.406L135.447 166.267L135.344 166.325L144.148 171.439Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.4959 120.465L43.7482 113.071L43.6455 113.129L56.3932 120.527L56.4959 120.465Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M14.4239 96.0587L5.3119 90.7705L5.2626 90.8614L14.3006 96.1165L14.4239 96.0587Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 135.289L81.9462 135.351L93.8723 142.27L93.975 142.208L82.0489 135.289Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M108.156 150.555L120.111 157.49L120.214 157.432L108.259 150.497L108.156 150.555Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M120.214 157.552L135.234 166.267L135.336 166.205L120.317 157.49L120.214 157.552Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M93.975 142.327L108.054 150.497L108.156 150.435L94.0777 142.27L93.975 142.327Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M81.9462 135.231L68.7301 127.565L68.6274 127.623L81.8434 135.289L81.9462 135.231Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M31.7235 120.048L31.6208 120.11L44.3685 127.503L44.4712 127.445L31.7235 120.048Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.9215 142.327L81.8435 149.246L81.9462 149.184L70.0242 142.27L69.9215 142.327Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.205 173.243L123.307 173.182L108.288 164.471L108.185 164.529L123.205 173.243Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M96.1277 157.536L108.082 164.471L108.185 164.409L96.2304 157.474L96.1277 157.536Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M31.6208 119.99L18.5485 112.406L18.4458 112.464L31.5181 120.048L31.6208 119.99Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 149.246L81.9462 149.304L96.025 157.474L96.1277 157.416L82.0489 149.246Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M2.5019 103.093L2.39919 103.155L18.3431 112.406L18.4458 112.344L2.5019 103.093Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.6027 134.48L44.5739 127.503L44.4712 127.561L56.5 134.542L56.6027 134.48Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M123.312 173.301L129.737 177.017L129.823 176.951L123.414 173.235L123.312 173.301Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M56.7054 134.542L56.6027 134.6L69.8188 142.27L69.9215 142.208L56.7054 134.542Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M2.39918 103.035L0.916128 102.177L0.891479 102.28L2.29648 103.106L2.39918 103.035Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M4.2643 120.576L0.842171 118.59C0.842171 118.636 0.842171 118.681 0.870928 118.727L4.15748 120.634L4.2643 120.576Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.3883 135.731L30.2856 135.793L42.3144 142.769L42.4171 142.711L30.3883 135.731Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M67.7647 157.536L81.8434 165.701L81.9461 165.643L67.8674 157.474L67.7647 157.536Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M55.8386 150.497L55.7359 150.555L67.662 157.474L67.7647 157.416L55.8386 150.497Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M55.7359 150.435L42.5239 142.769L42.4171 142.831L55.6332 150.497L55.7359 150.435Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.2856 135.673L17.542 128.275L17.4393 128.337L30.1829 135.731L30.2856 135.673Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M109.229 181.471L109.126 181.533L115.777 185.389L115.892 185.339L109.229 181.471Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 165.701L81.9462 165.763L93.901 172.699L94.0037 172.637L82.0489 165.701Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M4.367 120.634L4.2643 120.696L17.3366 128.275L17.4393 128.217L4.367 120.634Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M94.0037 172.756L109.023 181.471L109.126 181.413L94.1064 172.699L94.0037 172.756Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M5.37763 135.21L4.80248 134.876C4.78228 134.905 4.76442 134.935 4.74907 134.967L5.27493 135.272L5.37763 135.21Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M43.781 157.49L43.6783 157.552L55.6044 164.471L55.7071 164.409L43.781 157.49Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M69.8886 172.756L81.8435 179.692L81.9462 179.634L69.9913 172.699L69.8886 172.756Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M55.8098 164.471L55.7071 164.529L69.7859 172.699L69.8886 172.637L55.8098 164.471Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.4623 149.766L30.3596 149.824L43.5756 157.49L43.6783 157.432L30.4623 149.766Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M82.0489 179.692L81.9462 179.754L96.9657 188.468L97.0684 188.406L82.0489 179.692Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M97.0684 188.526L100.692 190.627L100.836 190.594L97.1711 188.468L97.0684 188.526Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M30.3596 149.705L18.3308 142.728L18.2281 142.786L30.2569 149.766L30.3596 149.705Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M5.48443 135.272L5.38172 135.33L18.1254 142.728L18.2281 142.666L5.48443 135.272Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M40.5849 173.182L28.6588 166.267L28.5561 166.325L40.4822 173.243L40.5849 173.182Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M3.2085 151.5L3.1058 151.558L15.1346 158.539L15.2373 158.477L3.2085 151.5Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M15.34 158.539L15.2373 158.597L28.4534 166.267L28.5561 166.205L15.34 158.539Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M3.1058 151.443L0 149.638V149.758L3.00309 151.5L3.1058 151.443Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M40.5849 173.301L54.6636 181.471L54.7663 181.413L40.6876 173.243L40.5849 173.301Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M54.869 181.471L54.7663 181.533L66.7212 188.468L66.8239 188.406L54.869 181.471Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M66.8403 188.526L76.2892 194H76.4823L66.9266 188.468L66.8403 188.526Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M27.9234 180.649L27.8207 180.707L41.8995 188.877L42.0022 188.819L27.9234 180.649Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M15.7919 173.611L6.03905 167.947L6.19105 168.153L15.7015 173.673L15.7919 173.611Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M15.8946 173.673L15.7919 173.731L27.718 180.649L27.8207 180.588L15.8946 173.673Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            opacity: "0.5",
            d: "M42.0022 188.939L45.5229 190.978L45.8762 191.065L42.1049 188.877L42.0022 188.939Z",
            fill: _vm.color,
          },
        }),
        _c("path", {
          attrs: {
            d: "M115.239 147.645L113.789 148.421C113.629 148.082 113.514 147.843 113.378 147.595L112.659 147.665C112.595 147.342 112.551 147.015 112.528 146.687C112.495 144.908 112.482 143.124 112.45 141.345C112.403 138.772 112.348 136.198 112.285 133.625C112.236 131.468 112.182 129.307 112.125 127.144C112.1 126.405 112.092 125.662 112.006 124.931C111.935 124.481 111.797 124.044 111.595 123.635C111.34 123.082 110.888 122.983 110.317 123.321C108.674 124.312 107.006 125.328 105.346 126.318C102.253 128.164 99.1513 129.997 96.066 131.842C94.8952 132.544 93.7572 133.291 92.5823 133.984C92.4366 134.053 92.3155 134.165 92.2354 134.306C92.1553 134.446 92.1201 134.608 92.1345 134.769C92.1961 137.691 92.2454 140.618 92.2988 143.545C92.2988 143.681 92.2988 143.822 92.2988 143.958C92.3563 147.108 92.3974 150.258 92.4673 153.403C92.5248 155.975 92.6152 158.547 92.6891 161.148C92.2249 161.457 91.8305 161.907 91.1526 161.779L90.9513 161.152L90.1009 161.197C90.064 160.227 90.0106 159.307 89.9941 158.386C89.9325 155.265 89.8873 152.144 89.8257 149.023C89.7805 146.724 89.7189 144.425 89.6614 142.125C89.6121 140.156 89.5504 138.187 89.5011 136.218C89.5076 135.934 89.4428 135.652 89.3129 135.4C89.183 135.147 88.992 134.932 88.7576 134.773C86.194 132.874 83.6634 130.93 81.1122 129.014C79.0828 127.495 77.0451 125.981 74.9992 124.473C74.3665 124.007 73.7175 123.561 72.9862 123.049C72.9492 123.247 72.9231 123.447 72.9081 123.647C72.9821 127.01 73.0574 130.378 73.1341 133.749C73.1341 133.91 73.1341 134.075 73.1341 134.24C73.1875 137.332 73.2327 140.433 73.3025 143.52C73.3518 145.737 73.434 147.95 73.5038 150.163L73.0026 150.497C72.5179 150.819 72.1399 150.658 72.029 150.084C71.9957 149.924 71.9764 149.761 71.9715 149.597C71.9386 148.061 71.9016 146.53 71.877 144.998C71.8482 143.298 71.8359 141.601 71.803 139.904C71.7578 137.63 71.6962 135.363 71.6428 133.089C71.5853 130.707 71.536 128.329 71.4785 125.947C71.4497 124.795 71.3963 123.647 71.3922 122.5C71.4027 122.284 71.3566 122.069 71.2586 121.876C71.1605 121.683 71.014 121.52 70.8335 121.402C68.0071 119.309 65.1929 117.195 62.3829 115.086C61.2039 114.202 60.0372 113.302 58.8622 112.415C57.4024 111.314 55.9427 110.213 54.4829 109.112C54.3856 109.067 54.2837 109.032 54.1789 109.009C54.1789 109.244 54.1337 109.446 54.1378 109.649C54.1912 111.482 54.2569 113.315 54.298 115.147C54.3596 117.938 54.4048 120.733 54.4665 123.524C54.5116 125.798 54.5733 128.065 54.6267 130.339C54.6842 132.721 54.7294 135.103 54.7951 137.481C54.7951 138.162 54.8732 138.843 54.9101 139.487C54.735 139.608 54.5541 139.719 54.3679 139.822C54.2717 139.869 54.1662 139.893 54.0594 139.892C53.9525 139.892 53.8473 139.866 53.7516 139.818C53.656 139.771 53.5726 139.701 53.5078 139.616C53.4429 139.531 53.3985 139.432 53.3778 139.326C53.3695 139.245 53.3695 139.164 53.3778 139.083C53.3531 137.96 53.3298 136.837 53.3079 135.714C53.2504 132.758 53.2011 129.798 53.1395 126.843C53.0943 124.572 53.0327 122.302 52.9793 120.027C52.9218 117.649 52.8766 115.267 52.8108 112.885C52.7698 111.383 52.6876 109.88 52.663 108.373C52.6789 108.199 52.6333 108.024 52.5342 107.88C52.4351 107.736 52.2887 107.631 52.1207 107.585C49.968 106.729 47.8208 105.865 45.679 104.992C44.2658 104.418 42.8567 103.824 41.4476 103.242C41.2504 103.163 41.0368 103.093 40.7738 102.99V104.464L39.4633 105.244L39.0525 104.567H38.1282C38.1282 104.022 38.1282 103.481 38.1282 102.949C38.161 102.28 38.0049 101.793 37.2654 101.586C36.7288 101.392 36.2071 101.159 35.7043 100.889C35.7043 101.987 35.7043 102.953 35.7043 103.89C35.7043 104.303 35.77 104.716 35.7783 105.128C35.807 106.937 35.8152 108.745 35.8522 110.553C35.8974 112.852 35.959 115.147 36.0124 117.447C36.0658 119.746 36.1151 122.157 36.1809 124.51C36.2178 125.955 36.2795 127.4 36.3288 128.824C36.1356 128.946 35.9338 129.054 35.7249 129.146C35.628 129.175 35.5258 129.183 35.4258 129.167C35.3258 129.151 35.2305 129.113 35.147 129.056C35.0635 128.999 34.9938 128.923 34.9431 128.835C34.8924 128.747 34.8619 128.649 34.8539 128.548C34.8087 127.974 34.7676 127.4 34.7553 126.826C34.7266 124.964 34.7184 123.111 34.6814 121.237C34.6376 118.776 34.5828 116.314 34.5171 113.851C34.4719 111.989 34.4061 110.136 34.3568 108.27C34.2911 105.649 34.2254 103.027 34.1596 100.307L17.7679 93.6272C17.7679 94.0401 17.7679 94.329 17.7679 94.618C17.8213 96.7812 17.8789 98.9443 17.9282 101.103C18.0103 104.744 18.0678 108.385 18.1664 112.027C18.2116 113.719 18.3472 115.412 18.3924 117.108C18.3924 117.595 18.3924 118.116 17.772 118.396C17.0244 118.731 17.0449 118.784 16.5396 118.066C16.3383 118.091 16.1288 118.124 15.9151 118.145C15.8446 118.136 15.7755 118.118 15.7097 118.091C15.6686 117.732 15.5906 117.356 15.5824 116.98C15.5495 115.143 15.5413 113.31 15.5084 111.473C15.4632 108.996 15.4016 106.495 15.3441 104.001C15.2948 101.76 15.2537 99.514 15.1757 97.2724C15.1223 95.6211 15.0113 93.9946 14.9292 92.3599C14.9292 92.0833 14.9292 91.8067 14.9292 91.5342C14.8916 91.345 14.9233 91.1485 15.0184 90.9809C15.1135 90.8133 15.2656 90.6858 15.4468 90.6219C15.5667 90.5838 15.6732 90.5118 15.7533 90.4144C15.8335 90.317 15.884 90.1984 15.8987 90.0729C15.9357 89.8912 16.2191 89.7344 16.4204 89.6146C17.6529 88.8716 18.9141 88.1491 20.1589 87.4102C22.1007 86.2543 24.0425 85.0929 25.9843 83.926C27.9891 82.7123 29.9857 81.4821 31.9946 80.2684C33.9296 79.096 35.881 77.9443 37.8159 76.776C41.1025 74.7862 44.389 72.7799 47.6756 70.7984C49.9639 69.4196 52.2727 68.082 54.5609 66.7032C57.0587 65.1964 59.5319 63.6525 62.0255 62.1622C63.5908 61.2127 65.1765 60.3045 66.7458 59.3716C68.8575 58.1166 70.965 56.8561 73.0684 55.5901C74.9417 54.4714 76.8191 53.3568 78.6802 52.2215C80.9356 50.8427 83.1704 49.4309 85.4299 48.0603C87.0403 47.0819 88.6836 46.1655 90.2981 45.1954C92.8411 43.6597 95.3718 42.0992 97.9106 40.5594C98.8185 40.0062 99.7429 39.4737 100.659 38.9329C102.98 37.5582 105.314 36.1959 107.643 34.8047C110.022 33.3681 112.376 31.8902 114.754 30.4454C116.155 29.6197 117.585 28.7941 118.986 27.9685C121.861 26.2346 124.717 24.4843 127.584 22.7422C127.766 22.6213 127.958 22.5177 128.159 22.4326C128.317 22.3594 128.493 22.3322 128.666 22.3541C128.839 22.376 129.002 22.4461 129.137 22.5564C130.258 23.4047 131.506 24.0693 132.834 24.5255C133.997 24.9012 135.106 25.4461 136.232 25.9333C136.729 26.1479 137.197 26.441 137.764 26.1355C137.867 26.0777 138.027 26.1355 138.22 26.1355C138.22 26.6928 138.594 26.9158 139.042 27.0933C141.318 27.9974 143.59 28.9221 145.861 29.8385C146.029 29.9257 146.213 29.9787 146.401 29.9942C146.589 30.0098 146.779 29.9878 146.958 29.9293C147.135 29.8975 147.316 29.8975 147.492 29.9293C147.483 30.1447 147.55 30.3564 147.682 30.5266C147.814 30.6968 148.001 30.8143 148.211 30.8582C149.686 31.4196 151.153 32.0099 152.619 32.5961C153.556 32.9718 154.48 33.3681 155.421 33.7314C155.623 33.7709 155.831 33.7709 156.033 33.7314C156.272 33.7314 156.506 33.6819 156.806 33.6488C156.8 33.8437 156.857 34.0353 156.969 34.1946C157.081 34.3539 157.241 34.4724 157.426 34.5323C159.698 35.4529 161.945 36.4188 164.221 37.3518C164.588 37.5301 165.004 37.5753 165.4 37.4798C165.955 37.327 166.037 37.4344 166.341 38.0371C166.43 38.1664 166.545 38.276 166.678 38.3591C168.181 39.4875 169.688 40.6145 171.197 41.7401C172.335 42.5864 173.469 43.4368 174.623 44.2583C174.834 44.3865 175.061 44.4878 175.297 44.5596C175.613 44.902 175.948 45.2272 176.299 45.5339C177.486 46.4545 178.686 47.3503 179.886 48.2544C181.213 49.2534 182.535 50.2606 183.879 51.239C184.119 51.3758 184.378 51.476 184.647 51.5363C184.941 51.878 185.258 52.1994 185.596 52.4981C188.114 54.4177 190.641 56.3167 193.163 58.2239C193.183 58.2426 193.205 58.2592 193.229 58.2735C193.714 58.5624 194.252 58.6863 194.63 59.2353C195.047 59.704 195.532 60.1075 196.068 60.4325C196.544 60.7958 197.045 61.1302 197.522 61.4893C199.223 62.769 200.922 64.0488 202.62 65.3285C202.748 65.4235 202.912 65.5638 203.031 65.5432C203.643 65.4441 203.931 65.9808 204.37 66.212C204.498 66.278 204.568 66.5257 204.596 66.6991C204.645 67.0243 204.67 67.3527 204.67 67.6816C204.67 68.7219 204.67 69.7457 204.67 70.7984C204.695 72.6836 204.726 74.5729 204.765 76.4664C204.839 80.1322 204.917 83.7994 204.999 87.468C205.048 89.4371 205.126 91.4063 205.192 93.4208L203.886 94.1763L203.389 93.5364H202.567C202.518 93.1236 202.44 92.7603 202.431 92.3847C202.398 90.5476 202.39 88.7106 202.357 86.8777C202.308 84.3595 202.253 81.8413 202.193 79.3231C202.144 77.259 202.082 75.2197 202.029 73.1638C201.996 71.7437 201.967 70.3195 201.93 68.8953C201.905 68.695 201.868 68.4965 201.819 68.3008C196.421 71.4506 191.171 74.6954 185.879 77.8452V82.5843C185.571 82.6999 185.407 83.1953 184.889 82.9517C184.372 82.7082 184.524 82.2747 184.507 81.8867C184.462 80.8835 184.425 79.8804 184.38 78.7245L182.178 80.1446C182.178 80.7886 182.178 81.4697 182.178 82.1509C182.178 82.477 182.227 82.8031 182.227 83.1334C182.227 84.1448 182.227 85.1562 182.227 86.1676C182.252 88.0941 182.283 90.0109 182.322 91.9182C182.396 95.5317 182.474 99.1439 182.556 102.755C182.589 104.15 182.654 105.541 182.704 106.974C182.466 107.118 182.248 107.271 182.009 107.386C181.36 107.721 181.323 107.704 180.929 107.052H180.025C179.988 106.061 179.935 105.108 179.918 104.162C179.857 101.041 179.812 97.9206 179.75 94.7996C179.705 92.5002 179.656 90.2008 179.582 87.9014C179.536 86.4855 179.421 85.0654 179.36 83.6494C179.338 83.4311 179.263 83.2213 179.143 83.038C179.023 82.8547 178.86 82.7033 178.67 82.5967C178.561 82.513 178.428 82.4677 178.292 82.4677C178.155 82.4677 178.022 82.513 177.914 82.5967C176.624 83.4224 175.321 84.2026 174.015 84.9911C172.076 86.1635 170.133 87.3235 168.19 88.4876C165.64 90.0151 163.09 91.5425 160.54 93.0699C160.216 93.264 159.92 93.5075 159.624 93.718C159.624 95.9679 159.603 98.1806 159.624 100.393C159.653 102.746 159.731 105.099 159.784 107.453C159.838 109.806 159.887 112.105 159.948 114.433C159.998 116.208 160.059 117.988 160.109 119.763C160.109 120.035 160.109 120.308 160.109 120.588L158.843 121.265L158.453 120.568L157.582 120.692C157.541 120.324 157.484 120.006 157.471 119.684C157.43 118.454 157.399 117.224 157.377 115.994C157.344 114.132 157.336 112.278 157.303 110.404C157.256 107.927 157.201 105.464 157.138 103.015C157.097 101.454 157.036 99.8979 156.974 98.3375C157.002 97.9016 156.961 97.4639 156.851 97.0412C156.619 96.5971 156.336 96.1815 156.009 95.8028L154.135 96.9711C153.93 97.099 153.725 97.2435 153.519 97.3839C152.036 98.2508 150.537 99.0971 149.066 99.9846C146.379 101.603 143.725 103.246 141.026 104.872C139.909 105.554 138.783 106.226 137.641 106.866C137.457 106.948 137.304 107.089 137.207 107.266C137.11 107.444 137.073 107.648 137.103 107.849C137.152 108.674 137.164 109.5 137.177 110.326C137.177 111.312 137.177 112.295 137.177 113.277C137.201 115.22 137.233 117.165 137.271 119.111C137.342 122.688 137.421 126.274 137.505 129.869C137.538 131.289 137.604 132.709 137.657 134.207L136.154 134.888L135.907 134.063L135.086 134.261C135.052 134.149 135.027 134.034 135.012 133.918C134.975 132.659 134.938 131.4 134.913 130.141C134.831 126.228 134.752 122.313 134.675 118.396C134.631 116.233 134.575 114.071 134.506 111.911C134.527 111.447 134.461 110.984 134.313 110.545C134.066 110.136 133.765 109.762 133.418 109.434L114.647 120.729C114.647 123.049 114.619 125.319 114.647 127.59C114.701 131.095 114.795 134.608 114.873 138.1C114.927 140.424 114.976 142.753 115.042 145.077C115.136 145.89 115.194 146.736 115.239 147.645ZM123.455 100.736L115.621 94.8533C114.799 95.3817 114.019 95.9184 113.205 96.4096C111.275 97.582 109.338 98.7434 107.396 99.8938C106.131 100.645 104.849 101.368 103.584 102.123C101.615 103.29 99.6539 104.468 97.7011 105.657C97.1177 106.008 96.5549 106.383 95.8647 106.817L103.625 112.65C104.771 111.977 105.86 111.362 106.912 110.71C109.405 109.203 111.883 107.667 114.376 106.169C116.66 104.786 118.961 103.428 121.249 102.04L123.455 100.736ZM94.2872 105.653L114.101 93.7222L106.32 87.9056L86.5104 99.8278L94.2872 105.653ZM131.483 72.7345L139.26 78.58L159.09 66.6537L151.284 60.8123L131.483 72.7345ZM82.2502 100.257L80.344 98.837C78.7007 97.5986 77.0574 96.389 75.4141 95.1836C74.498 94.5148 74.157 94.5313 73.2409 95.1836C73.1505 95.2455 73.056 95.2992 72.9615 95.3528C71.0307 96.5294 69.1039 97.7141 67.1649 98.8742C64.0057 100.761 60.8342 102.627 57.675 104.513C56.6808 105.108 55.7112 105.752 54.6595 106.392L62.3583 112.171C62.5883 112.06 62.7445 112.006 62.8841 111.919C66.2885 109.863 69.6942 107.806 73.1012 105.748C75.484 104.311 77.879 102.899 80.2659 101.475C80.9068 101.083 81.523 100.703 82.2502 100.257ZM107.417 85.1149C114.031 81.1477 120.6 77.2342 127.231 73.1803C126.758 72.8377 126.409 72.59 126.072 72.3341C124.244 70.9552 122.42 69.5682 120.588 68.2059C120.367 68.0449 120.127 67.9131 119.873 67.8137C119.651 67.7139 119.407 67.6729 119.165 67.6946C118.922 67.7163 118.69 67.7999 118.489 67.9375C117.408 68.627 116.278 69.2338 115.181 69.8984C112.306 71.6488 109.405 73.4198 106.513 75.1701C104.365 76.4705 102.208 77.7502 100.059 79.0382C99.9334 79.1319 99.8139 79.2339 99.7018 79.3437L107.417 85.1149ZM168.395 73.6675L160.75 67.888C159.554 68.3586 141.466 79.2777 140.952 79.8597C141.437 80.2106 141.922 80.5574 142.398 80.9166C144.315 82.3642 146.226 83.8145 148.129 85.2677C148.247 85.3793 148.4 85.4464 148.562 85.4577C148.724 85.469 148.884 85.4237 149.017 85.3296C150.426 84.5039 151.847 83.6783 153.248 82.8527C156.165 81.0941 159.065 79.3107 161.978 77.5438C164.073 76.2558 166.181 75.0009 168.395 73.6675ZM81.1738 126.203C82.168 125.588 83.154 124.964 84.1523 124.357C86.1283 123.152 88.1044 121.942 90.0927 120.758C93.2506 118.872 96.4139 116.994 99.5827 115.123C99.9935 114.875 100.404 114.611 100.93 114.276L93.1246 108.419C92.0441 109.087 91.0089 109.735 89.9654 110.375C88.0099 111.564 86.0585 112.757 84.0948 113.938C81.8079 115.314 79.5155 116.683 77.2176 118.045C76.1166 118.698 74.9992 119.329 73.8941 119.977C73.7267 120.102 73.57 120.24 73.4258 120.39L81.1738 126.203ZM128.829 74.3693C128.126 74.7821 127.457 75.1949 126.775 75.6077C125.542 76.326 124.31 77.0195 123.098 77.7544C120.744 79.1786 118.406 80.6441 116.052 82.0559C113.813 83.41 111.562 84.7475 109.319 86.0974C109.238 86.1504 109.159 86.2083 109.085 86.2708C109.148 86.3536 109.218 86.4309 109.294 86.502L114.224 90.1802C114.902 90.6838 115.568 91.1999 116.25 91.6994C116.504 91.8893 116.755 92.1122 117.129 91.9058C118.747 90.9439 120.382 90.0109 121.993 89.0161C124.207 87.6744 126.401 86.2956 128.615 84.958C130.904 83.5751 133.208 82.2211 135.501 80.8299C135.846 80.6235 136.174 80.384 136.556 80.1281L128.829 74.3693ZM91.6086 107.271L83.8031 101.43L64.0098 113.343L71.8154 119.177L91.6086 107.271ZM126.163 99.1053L145.927 87.2038L138.122 81.3583C131.528 85.3585 124.947 89.2555 118.369 93.2722L126.163 99.1053ZM77.193 92.7975C77.4559 93.0245 77.6038 93.1731 77.7887 93.3011C78.8815 94.1268 79.9824 94.9111 81.0752 95.7244C82.168 96.5376 83.2978 97.3756 84.3947 98.2508C84.5355 98.3978 84.7256 98.4871 84.9281 98.5016C85.1307 98.5161 85.3314 98.4547 85.4915 98.3292C86.5802 97.6522 87.7059 97.0371 88.8027 96.3725C91.6785 94.6304 94.5214 92.8718 97.3889 91.1379C99.7429 89.7137 102.117 88.3184 104.48 86.9066C104.552 86.8518 104.618 86.7895 104.677 86.7208C104.541 86.6052 104.422 86.4979 104.295 86.3988C102.705 85.2016 101.127 83.992 99.521 82.8196C98.7774 82.2747 97.9887 81.7959 97.2081 81.3005C97.0719 81.2103 96.9113 81.1643 96.7482 81.1687C96.5851 81.1732 96.4273 81.2278 96.2961 81.3252C94.7021 82.2747 93.0876 83.1829 91.4977 84.1407C88.4864 85.9529 85.4874 87.7941 82.4802 89.6146C80.7589 90.6591 79.0293 91.6911 77.193 92.7975ZM177.117 81.0445C174.73 78.7782 172.651 76.454 169.857 74.8811C169.525 75.0917 169.139 75.3435 168.744 75.5788C167.056 76.5778 165.355 77.5603 163.679 78.5759C161.395 79.9588 159.135 81.3789 156.847 82.7577C155.52 83.5627 154.152 84.3058 152.821 85.1025C151.958 85.6186 151.124 86.1841 150.2 86.7538L157.952 92.5704L177.117 81.0445ZM124.877 101.941C123.911 102.548 122.905 103.18 121.882 103.816C119.946 104.991 118.005 106.159 116.061 107.32L107.7 112.303C106.879 112.786 106.086 113.277 105.17 113.831L112.996 119.693C114.113 118.995 115.165 118.322 116.233 117.674C118.15 116.515 120.067 115.362 121.985 114.215C124.91 112.464 127.837 110.719 130.768 108.98C131.179 108.724 131.61 108.439 132.099 108.125C129.782 105.904 127.711 103.593 124.877 101.941ZM147.361 88.401C146.539 88.9087 145.673 89.4619 144.785 89.9944C143.265 90.9068 141.729 91.7902 140.213 92.7108C137.883 94.1226 135.575 95.5716 133.229 96.9793C131.783 97.8504 130.3 98.6677 128.845 99.5264C128.473 99.7729 128.114 100.039 127.769 100.323L135.492 106.103L154.641 94.5437C152.291 92.3392 150.113 90.0687 147.361 88.401ZM82.698 127.346L90.5035 133.192L109.155 121.967C109.237 121.265 109.249 121.253 108.843 120.865C108.193 120.246 107.491 119.676 106.866 119.028C105.523 117.69 104.044 116.496 102.454 115.465L82.698 127.346ZM122.137 65.7331L129.971 71.6075C130.538 71.2277 131.105 70.8149 131.705 70.4516C133.66 69.2654 135.621 68.0889 137.588 66.922L144.255 62.9424C145.118 62.4264 145.972 61.8856 146.847 61.3861C146.983 61.322 147.095 61.2173 147.168 61.0864C147.242 60.9555 147.273 60.805 147.258 60.6554C147.258 59.8876 147.258 59.1197 147.258 58.356C147.27 58.2079 147.244 58.0591 147.181 57.9244C147.118 57.7898 147.022 57.6739 146.901 57.5882C145.59 56.6139 144.329 55.5695 142.99 54.6324C142.328 54.17 141.61 53.9141 140.759 54.5086C139.56 55.3342 138.261 56.0525 137 56.8038C135.41 57.7533 133.804 58.6739 132.214 59.6316C129.466 61.2829 126.721 62.9631 123.977 64.6309L122.137 65.7331ZM165.112 40.064C164.904 40.1015 164.7 40.161 164.504 40.2415C163.486 40.8236 162.471 41.4098 161.469 42.0167C159.004 43.5069 156.588 45.0179 154.139 46.4999C152.274 47.6269 150.393 48.7208 148.503 49.8354C148.503 50.174 148.503 50.4464 148.503 50.7189C148.532 51.8128 148.651 52.9109 148.573 53.9967C148.513 54.382 148.576 54.7765 148.754 55.1231C148.932 55.4697 149.216 55.7504 149.563 55.9245C149.912 56.1309 150.204 56.4364 150.532 56.6759C151.169 57.1341 151.814 57.5758 152.435 58.0134C153.125 57.6006 153.749 57.2827 154.357 56.9112C156.777 55.4415 159.188 53.9512 161.612 52.4816C162.73 51.8046 163.861 51.1468 165.006 50.5083C165.138 50.4473 165.247 50.3434 165.314 50.2132C165.381 50.083 165.402 49.9341 165.375 49.79C165.318 48.0108 165.293 46.2274 165.26 44.4482C165.236 43.1643 165.215 41.8763 165.186 40.5883C165.177 40.4126 165.158 40.2376 165.129 40.064H165.112ZM183.805 53.8728L167.286 63.8052C167.286 65.0726 167.286 66.245 167.286 67.4174C167.286 67.8302 167.351 68.243 167.335 68.6558C167.323 68.8317 167.358 69.0076 167.438 69.1648C167.517 69.3219 167.638 69.4542 167.787 69.5475C168.859 70.3401 169.919 71.1534 170.987 71.9543C171.052 71.985 171.121 72.0059 171.193 72.0162C171.743 71.6735 172.265 71.3268 172.799 71.0089C175.749 69.2462 178.698 67.4958 181.648 65.7331C182.277 65.3574 182.88 64.9075 183.521 64.5731C184.059 64.2965 184.125 63.8878 184.113 63.3635C184.043 61.0682 184.002 58.7688 183.94 56.4736C183.924 55.681 183.871 54.9007 183.821 53.8728H183.805ZM52.6712 105.364C52.9384 105.127 53.2196 104.906 53.5133 104.703C54.5897 104.059 55.6866 103.465 56.7588 102.8C59.4168 101.194 62.0625 99.5677 64.7246 97.966C66.2898 97.0206 67.8756 96.1165 69.4408 95.1753C70.2049 94.7171 70.9444 94.2093 71.8236 93.6396C71.31 93.4539 70.9362 93.3341 70.5911 93.1855C68.6562 92.3847 66.7171 91.5879 64.7903 90.7623C64.6347 90.683 64.4603 90.6484 64.2864 90.6622C64.1124 90.6761 63.9457 90.7378 63.8044 90.8407C63.2785 91.1833 62.7239 91.4723 62.1899 91.7984C59.9098 93.1855 57.638 94.5932 55.3497 95.972C52.5479 97.6563 49.7256 99.3159 46.9197 100.992C46.3035 101.359 45.6872 101.756 44.9847 102.21C47.6468 103.308 50.1898 104.344 52.6712 105.364ZM139.239 53.1008C139.164 53.0411 139.084 52.9873 139.001 52.9398L132.21 50.1286C132.061 50.0664 131.898 50.0447 131.738 50.0657C131.578 50.0867 131.426 50.1497 131.298 50.2483C129.134 51.5638 126.964 52.8697 124.786 54.1659L118.965 57.6501C116.979 58.8418 114.997 60.0403 113.016 61.2458C112.871 61.3444 112.733 61.4548 112.606 61.576C112.848 61.6916 113.037 61.7989 113.238 61.8774C115.292 62.703 117.346 63.5286 119.364 64.3543C119.587 64.4742 119.84 64.5292 120.093 64.5132C120.347 64.4972 120.59 64.4107 120.797 64.2635C122.17 63.3759 123.57 62.5296 124.971 61.6833C126.204 60.9526 127.436 60.2632 128.636 59.5284C130.825 58.2033 132.999 56.8451 135.188 55.52C136.38 54.8017 137.592 54.1164 138.791 53.4146C138.946 53.3178 139.095 53.2131 139.239 53.1008V53.1008ZM67.662 88.5826C67.766 88.6541 67.8744 88.7189 67.9865 88.7766C69.1615 89.2748 70.3391 89.7701 71.5196 90.2628C72.5754 90.7045 73.6394 91.1214 74.687 91.5797C74.8309 91.6544 74.9929 91.6866 75.1543 91.6727C75.3156 91.6589 75.4698 91.5994 75.599 91.5012C75.9811 91.237 76.3467 90.9522 76.7411 90.7127C78.6309 89.5734 80.5234 88.4381 82.4186 87.307C85.5545 85.441 88.6932 83.5751 91.8346 81.7092C92.6562 81.222 93.445 80.6936 94.3488 80.1239C91.8839 79.1332 89.6038 78.2126 87.3156 77.2342C87.137 77.1449 86.9377 77.1057 86.7388 77.121C86.5399 77.1363 86.3488 77.2053 86.1858 77.3209C83.2361 79.1346 80.2782 80.9234 77.3121 82.6875C74.2269 84.5411 71.1293 86.3658 68.0399 88.2111C67.9026 88.3227 67.776 88.4471 67.662 88.5826ZM116.784 66.6578C116.455 66.4927 116.27 66.3812 116.073 66.2987C113.937 65.407 111.796 64.5277 109.668 63.6236C109.535 63.5636 109.387 63.5419 109.242 63.5608C109.097 63.5798 108.96 63.6386 108.847 63.7309C108.025 64.2593 107.175 64.7547 106.337 65.2625C103.075 67.2399 99.8168 69.2297 96.5508 71.1947C95.1253 72.0533 93.6751 72.846 92.2372 73.7046C91.5306 74.1174 90.8527 74.6004 90.0393 75.1288C90.3803 75.2362 90.557 75.2775 90.7254 75.3435C92.8411 76.2187 94.9568 77.0897 97.0643 77.9773C97.2148 78.066 97.3871 78.1104 97.5614 78.1053C97.7358 78.1002 97.9053 78.0458 98.0503 77.9484C98.6624 77.5356 99.3033 77.1682 99.9318 76.7884C101.883 75.5995 103.831 74.3981 105.794 73.2257C108.979 71.3268 112.169 69.4361 115.362 67.5536C115.794 67.2894 116.221 67.0087 116.775 66.6578H116.784ZM105.552 61.9971C103.909 61.3242 102.228 60.6637 100.581 59.9578C100.402 59.8678 100.201 59.8276 100.001 59.8414C99.8013 59.8552 99.6085 59.9224 99.443 60.0362C98.2105 60.7999 96.978 61.5471 95.7456 62.2902C92.522 64.2167 89.2916 66.1432 86.0544 68.0696C85.886 68.1546 85.7482 68.29 85.6598 68.4571C85.5715 68.6243 85.5371 68.8149 85.5614 69.0026C85.6025 70.3443 85.6148 71.6818 85.6435 73.0235C85.6589 73.1324 85.6823 73.24 85.7134 73.3455C86.4036 73.622 87.1389 73.8986 87.862 74.2083C88.0222 74.28 88.1986 74.3071 88.3728 74.2867C88.547 74.2664 88.7125 74.1994 88.852 74.0927C90.3597 73.1597 91.8757 72.2474 93.3916 71.335C96.0592 69.7361 98.7254 68.1412 101.39 66.5505C102.676 65.7826 103.954 65.0024 105.236 64.2304C105.474 64.0859 105.7 63.9538 105.667 63.6112C105.609 63.0952 105.585 62.575 105.544 61.9971H105.552ZM128.052 48.4443C126.224 47.7094 124.458 47.0118 122.712 46.2893C122.598 46.2482 122.475 46.2388 122.357 46.262C122.238 46.2853 122.128 46.3404 122.038 46.4214C121.11 46.9911 120.185 47.5691 119.253 48.1305C116.64 49.6992 114.024 51.2652 111.406 52.8284C110.449 53.4022 109.488 53.9719 108.53 54.5209C108.381 54.5843 108.257 54.6937 108.174 54.8333C108.091 54.9729 108.055 55.1353 108.07 55.297C108.099 55.9245 108.07 56.5561 108.07 57.1836C108.099 58.0547 108.156 58.9175 108.202 59.7596C108.941 60.0857 109.619 60.3747 110.285 60.6843C110.44 60.765 110.615 60.8008 110.79 60.7876C110.965 60.7745 111.132 60.7131 111.275 60.61C113.173 59.4294 115.077 58.2652 116.989 57.1176C119.088 55.8543 121.196 54.6076 123.303 53.3568L128.069 50.529L128.052 48.4443ZM60.5219 89.0821C58.9608 88.4257 57.4161 87.8189 55.9166 87.1212C55.6772 86.9681 55.3958 86.8948 55.1126 86.9119C54.8293 86.9289 54.5586 87.0354 54.3391 87.2162C54.2484 87.2776 54.1537 87.3327 54.0556 87.3813C51.2949 89.0326 48.5342 90.6838 45.7735 92.3351C44.0481 93.3713 42.3349 94.4281 40.6835 95.4354C40.6835 97.0371 40.6835 98.5645 40.6835 100.096C40.6779 100.233 40.7199 100.368 40.8024 100.477C40.8849 100.586 41.0026 100.663 41.1353 100.695L43.477 101.591C43.7079 101.382 43.9492 101.184 44.2001 101C44.5657 100.765 44.9601 100.587 45.3298 100.344L53.994 95.0762L58.9567 92.0627C59.5031 91.7324 60.0659 91.4145 60.6 91.0884L60.5219 89.0821ZM83.117 75.5664L78.1872 73.5023C78.1132 73.4693 78.0187 73.5023 77.9489 73.4487C77.7923 73.367 77.6152 73.3336 77.4398 73.3527C77.2644 73.3718 77.0985 73.4425 76.9629 73.556C75.4347 74.4972 73.8968 75.4274 72.3494 76.3467C69.4545 78.086 66.5528 79.8143 63.6442 81.5317C63.4721 81.6071 63.3279 81.7349 63.2321 81.8972C63.1363 82.0594 63.0936 82.2478 63.1101 82.4357C63.1553 83.7485 63.1717 85.0612 63.1799 86.374C63.1608 86.5224 63.1974 86.6727 63.2824 86.7955C63.3674 86.9184 63.4949 87.005 63.6401 87.0387C64.2601 87.2444 64.869 87.4828 65.4641 87.7528C65.5947 87.8155 65.7395 87.8424 65.8837 87.8308C66.028 87.8192 66.1667 87.7695 66.2857 87.6868C67.5182 86.9189 68.726 86.147 69.9831 85.4039C72.8588 83.6824 75.7346 81.9816 78.6103 80.2643C80.1262 79.3561 81.6298 78.4231 83.1293 77.5108L83.117 75.5664ZM17.4763 90.6302C18.113 91.3526 21.5598 92.88 24.9943 94.0235C25.2489 93.7765 25.5237 93.5514 25.8159 93.3506C28.9381 91.4558 32.0686 89.5775 35.1949 87.6868C36.0165 87.1831 36.8382 86.6506 37.705 86.1098C37.6187 83.6329 37.5325 81.222 37.4421 78.6254C36.8752 78.9804 36.4315 79.2694 35.9796 79.5419C33.9775 80.7583 31.9741 81.972 29.9693 83.1829C27.9645 84.3939 25.9569 85.6034 23.9467 86.8116C21.8063 88.0831 19.6659 89.3339 17.4763 90.6302ZM82.4515 51.5404L62.5021 63.5493C62.7317 63.9292 63.1004 64.2034 63.5291 64.313C64.1084 64.5483 64.6917 64.7795 65.2751 65.0065C66.6144 65.5391 67.9701 66.0344 69.2888 66.6083C69.4866 66.6937 69.7039 66.7227 69.917 66.6922C70.1301 66.6616 70.3306 66.5725 70.4966 66.4349C72.4987 65.2129 74.5021 63.9965 76.5069 62.7856L82.5378 59.1651C82.6174 59.0982 82.6903 59.0235 82.7555 58.9422C82.6569 56.5726 82.5624 54.1494 82.4515 51.5404ZM107.557 36.4188C107.815 36.939 107.811 36.9473 108.218 37.1165C108.999 37.4344 109.783 37.7357 110.564 38.0536C111.848 38.582 113.13 39.1159 114.409 39.6553C114.515 39.7134 114.635 39.7417 114.756 39.7374C114.876 39.733 114.994 39.6961 115.095 39.6306C116.065 39.0196 117.051 38.4417 118.028 37.8513L124.31 34.0493L127.736 31.9852C127.506 29.5083 127.707 27.0685 127.407 24.5544C127.108 24.7031 126.91 24.7856 126.73 24.8971C125.653 25.5452 124.589 26.2057 123.513 26.8456C121.898 27.8075 120.267 28.7404 118.657 29.7105C115.905 31.3618 113.164 33.0502 110.416 34.718C109.471 35.296 108.51 35.8533 107.561 36.4188H107.557ZM104.862 38.0701L85.0848 49.9758C85.1875 50.4753 85.5162 50.5579 85.8202 50.6859C87.7264 51.4743 89.6408 52.2628 91.5429 53.0719C91.7475 53.1739 91.9757 53.2186 92.2035 53.2012C92.4313 53.1837 92.6501 53.1049 92.837 52.9729C94.7391 51.8005 96.6658 50.6693 98.5885 49.5217C100.597 48.3163 102.602 47.1026 104.615 45.9013C104.94 45.7114 105.19 45.5256 105.178 45.0757C105.141 44.1468 105.178 43.2138 105.125 42.285C105.047 40.9144 104.956 39.5439 104.866 38.0577L104.862 38.0701ZM59.8318 65.1675L39.9234 77.1393C40.1868 77.3454 40.461 77.5369 40.7451 77.7131C40.9466 77.7943 41.1523 77.8646 41.3613 77.9236C43.173 78.6667 44.9888 79.4098 46.7923 80.1735C46.947 80.2522 47.12 80.2873 47.2929 80.2749C47.4659 80.2626 47.6322 80.2033 47.7742 80.1033C48.9532 79.3685 50.1446 78.6543 51.336 77.9401C54.0967 76.2889 56.8602 74.6376 59.6263 72.9863C59.7865 72.9123 59.92 72.7907 60.009 72.6378C60.0979 72.4849 60.1379 72.3083 60.1234 72.1318C60.0454 70.0677 59.992 67.9747 59.9262 65.8982C59.9262 65.7248 59.8852 65.5349 59.8318 65.1675ZM130.583 46.2109C131.405 46.5618 132.074 46.8343 132.736 47.1521C132.913 47.2504 133.115 47.2937 133.317 47.2769C133.519 47.26 133.711 47.1835 133.87 47.0572C134.478 46.6444 135.102 46.2315 135.731 45.8765C138.845 44.0188 141.967 42.1612 145.077 40.3159C145.656 39.9691 146.198 39.5645 146.79 39.1641C146.675 36.9638 146.79 34.78 146.572 32.6911C146.347 32.4903 146.059 32.3759 145.758 32.3684C145.457 32.3608 145.164 32.4605 144.929 32.6498C142.115 34.4167 139.26 36.1175 136.413 37.8307C134.453 39.0072 132.477 40.1631 130.575 41.286L130.583 46.2109ZM200.792 66.8147L192.987 60.9733L185.526 65.4648C185.608 68.9366 185.686 72.3134 185.768 75.843L200.792 66.8147ZM167.232 61.6586C168.272 61.2457 181.492 53.2247 181.977 52.7004L174.327 46.9581C171.973 48.3823 169.689 49.7653 167.397 51.1317C167.243 51.2149 167.118 51.3433 167.039 51.4997C166.96 51.656 166.93 51.833 166.953 52.0069C167.019 55.0452 167.068 58.0836 167.13 61.1219C167.147 61.2995 167.182 61.475 167.232 61.6462V61.6586ZM172.787 73.267C172.951 73.4115 173.111 73.556 173.284 73.6798C175.482 75.3311 177.696 76.9617 179.857 78.6337C180.011 78.7833 180.213 78.8716 180.427 78.8822C180.641 78.8929 180.852 78.8251 181.019 78.6915C181.927 78.1383 182.839 77.5892 183.772 77.0773C183.968 76.9899 184.131 76.8418 184.238 76.6547C184.344 76.4676 184.388 76.2512 184.364 76.037C184.306 74.5055 184.285 72.9739 184.261 71.4424C184.236 69.9108 184.211 68.3793 184.187 66.8436C184.181 66.7135 184.167 66.584 184.146 66.4555C183.394 66.6908 173.682 72.5033 172.787 73.2546V73.267ZM161.814 65.0561C162.956 64.3501 164.024 63.6484 165.137 63.0209C165.332 62.9308 165.492 62.7802 165.595 62.5914C165.698 62.4026 165.738 62.1855 165.708 61.9723C165.655 60.6059 165.634 59.2395 165.605 57.873C165.577 56.5066 165.569 55.1938 165.527 53.8563C165.527 53.3816 165.433 52.9068 165.375 52.3536L154 59.1982L161.814 65.0561ZM148.478 47.5237C148.75 47.3833 148.918 47.309 149.078 47.214C150.265 46.4957 151.453 45.7692 152.644 45.055C155.24 43.5001 157.842 41.9479 160.45 40.3984C161.111 39.9856 161.764 39.5934 162.504 39.16C162.253 39.0279 162.118 38.9453 161.97 38.8834C159.833 37.9958 157.693 37.1206 155.561 36.2166C155.372 36.142 155.167 36.1172 154.965 36.1447C154.764 36.1722 154.573 36.2509 154.411 36.3734C153.018 37.1991 151.625 37.9834 150.245 38.8132C149.596 39.2012 148.984 39.6388 148.306 40.1094C148.347 42.4955 148.409 44.9724 148.478 47.5113V47.5237ZM143.984 31.5847C143.618 31.4114 143.38 31.2834 143.134 31.1719C141.08 30.3215 139.001 29.4835 136.947 28.6166C136.787 28.545 136.611 28.5172 136.437 28.5361C136.263 28.5549 136.098 28.6197 135.957 28.7239C134.995 29.2936 134.026 29.8468 133.081 30.4206C132.136 30.9944 131.228 31.5476 130.316 32.1049C130.378 34.6355 130.431 37.0794 130.493 39.6966C135.036 36.9431 139.449 34.297 143.984 31.5724V31.5847ZM120.674 45.6206C120.597 45.5426 120.512 45.4734 120.419 45.4142C118.968 44.7922 117.516 44.1743 116.065 43.5606C115.99 43.5259 115.911 43.4996 115.831 43.4822C114.951 43.3047 114.076 43.0982 113.189 42.9703C112.818 42.909 112.437 42.9623 112.096 43.123C110.671 43.9198 109.278 44.7743 107.815 45.6536C107.877 48.1305 107.943 50.6074 108.013 53.2453L120.674 45.6206ZM85.5696 66.7362L98.2187 59.1445C98.1694 59.0904 98.1143 59.0419 98.0544 59C95.5895 57.8565 93.1246 56.8492 90.4214 56.4488C90.1854 56.412 89.9438 56.451 89.7312 56.5603C88.4084 57.324 87.102 58.1125 85.7914 58.8968C85.6312 58.9959 85.4833 59.1074 85.4135 59.1528C85.4135 60.4738 85.3519 61.704 85.4135 62.9301C85.4751 64.1561 85.3272 65.3987 85.5696 66.7115V66.7362ZM75.8003 72.59C74.6336 72.107 73.6147 71.6694 72.5836 71.2607C71.836 70.9447 71.0722 70.6691 70.2953 70.4351C69.5928 70.2369 68.8369 70.2287 68.1385 70.0223C67.9045 69.9588 67.6589 69.9512 67.4214 69.9999C67.1839 70.0486 66.961 70.1524 66.7705 70.303L64.4165 71.7726L62.8513 72.7469C62.917 75.1949 62.9786 77.6429 63.0485 80.2437C67.3662 77.7213 71.5278 75.1784 75.8003 72.59ZM53.3449 86.1098C52.0549 85.5814 50.958 85.1025 49.8406 84.6856C49.019 84.3718 48.1522 84.1118 47.2894 83.8599C46.7718 83.7155 46.2172 83.6824 45.6996 83.5421C45.4932 83.4799 45.2757 83.4643 45.0627 83.4964C44.8496 83.5286 44.6462 83.6076 44.4671 83.7279C43.1484 84.5535 41.8214 85.3502 40.4986 86.1635C40.4575 86.1882 40.437 86.246 40.3836 86.3162L40.5561 93.8006L53.3449 86.1098ZM146.831 41.0383C145.923 41.319 135.649 47.5278 135.151 48.0975C135.944 48.4154 136.729 48.7167 137.51 49.0346C139.068 49.6703 140.626 50.3102 142.185 50.9542C142.307 51.0108 142.442 51.0348 142.577 51.0239C142.711 51.0131 142.841 50.9678 142.953 50.8923C144.304 50.0666 145.664 49.2781 146.999 48.4814C146.95 45.9467 146.889 43.5028 146.831 41.0383ZM34.135 97.8132C35.3674 96.7399 36.7478 96.2156 37.8077 95.4643C37.8077 94.1267 37.8529 92.8965 37.8077 91.6663C37.7625 90.4361 37.9597 89.1894 37.6598 87.9056C36.3493 88.6817 35.1045 89.4041 33.8721 90.143C32.6396 90.882 31.4277 91.5879 30.2363 92.3599C29.0449 93.1319 27.7303 93.7057 26.4937 94.6634L34.135 97.8132ZM82.7021 60.7917C81.1533 61.6957 79.736 62.509 78.331 63.347C76.433 64.4699 74.5418 65.6051 72.6575 66.7527C72.3042 66.9674 71.992 67.2399 71.5689 67.5536C74.0338 68.565 76.3344 69.5104 78.6391 70.4764C78.7871 70.5429 78.9498 70.5696 79.1112 70.5536C79.2726 70.5377 79.427 70.4798 79.5593 70.3856L82.8459 68.3215C82.8459 67.017 82.8787 65.7909 82.8459 64.5648C82.813 63.3387 82.9486 62.1168 82.7021 60.7917V60.7917ZM105.219 47.3627C104.328 47.6227 94.6117 53.5219 94.1557 54.0751L101.62 57.0969C102.709 56.4158 103.802 55.7016 104.907 55.0328C105.077 54.9553 105.218 54.8256 105.309 54.6623C105.401 54.499 105.438 54.3107 105.416 54.1246C105.359 52.5931 105.346 51.0656 105.305 49.5341C105.305 48.824 105.256 48.0975 105.219 47.3627V47.3627ZM116.447 40.4562L118.447 41.2571C120.21 41.9754 121.976 42.6896 123.735 43.4161C123.859 43.466 123.994 43.4823 124.127 43.4635C124.259 43.4447 124.385 43.3913 124.491 43.3088C125.403 42.7597 126.323 42.2355 127.235 41.6905C127.421 41.5637 127.599 41.4258 127.769 41.2777C127.769 38.9205 127.769 36.6831 127.769 34.4414C127.745 34.1882 127.702 33.9371 127.642 33.6901L116.447 40.4562ZM48.9984 80.9991C49.3476 81.1684 49.5818 81.3005 49.8201 81.4119C50.6787 81.7628 51.5414 82.0931 52.3959 82.444C53.6284 82.9518 54.8608 83.4636 56.0933 83.9921C56.2499 84.0703 56.4248 84.1044 56.5991 84.0906C56.7735 84.0768 56.9409 84.0156 57.0834 83.9136C57.9748 83.3398 58.8704 82.7577 59.7989 82.2623C59.9964 82.1809 60.1619 82.0367 60.2702 81.8519C60.3785 81.667 60.4236 81.4516 60.3987 81.2386C60.3412 79.7359 60.333 78.2332 60.2878 76.7264C60.2878 75.9999 60.2179 75.2733 60.1768 74.4105C56.3562 76.4994 52.7985 78.8236 48.9984 80.9991ZM185.501 63.314C187.605 62.2365 189.454 60.9774 191.421 59.7637L185.321 55.2227C185.325 58.001 185.432 60.5976 185.501 63.314ZM172.766 45.8187C170.712 44.2459 168.81 42.7556 166.665 41.2777C166.735 44.0312 166.801 46.5866 166.871 49.3194L172.766 45.8187ZM153.273 35.3042L148.179 33.2401C148.179 34.1401 148.15 34.9533 148.179 35.7583C148.207 36.5633 148.002 37.4096 148.363 38.2807L153.273 35.3042ZM134.7 27.7538L130.127 25.8837C130.18 27.4566 130.226 28.8767 130.279 30.4825L134.7 27.7538ZM144.58 52.1885C145.508 52.7747 146.108 53.5302 147.086 53.8935C147.086 53.3196 147.086 52.8284 147.086 52.3371C147.086 51.8459 147.061 51.3876 147.045 50.7767L144.58 52.1885ZM165.766 64.7877C164.926 65.1857 164.135 65.6788 163.408 66.2574L165.766 67.9747V64.7877ZM110.346 42.4212L107.795 41.9093V44.0147L110.346 42.4212ZM85.3272 57.5345L87.8743 55.9163L85.3272 55.5034V57.5345ZM35.7618 98.4035C36.4432 98.7788 37.1732 99.0566 37.931 99.2292V97.0701L35.7618 98.4035ZM40.2809 82.5059C40.3301 83.1994 40.3753 83.7898 40.4246 84.5122L42.7129 83.1458V82.9724L40.2809 82.5059ZM65.1971 69.6301L65.1478 69.403L62.8307 69.0274C62.7501 69.6699 62.7639 70.3209 62.8718 70.9594L65.1971 69.6301ZM105.425 58.7152V56.4653L103.194 57.7451L105.425 58.7152ZM82.9691 69.9727L80.7178 71.3144L82.9691 72.1854V69.9727ZM127.884 42.9084L125.756 44.1881C126.578 44.5349 127.202 44.9559 128.02 45.0922C127.974 44.3697 127.933 43.734 127.884 42.9084ZM60.411 83.5751L58.2131 84.8755L60.4233 85.7011L60.411 83.5751ZM148.848 59.0537V60.1683L149.723 59.6151L148.848 59.0537Z",
            fill: _vm.color,
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2_3" } }, [
          _c("rect", { attrs: { width: "218", height: "194", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }